define((require) => {
    "use strict";

    const $               = require("jquery");
    const AssociatedModel = require("backbone.associations");

    /**
     * SVG content.
     *
     * Storing it as strings in the code has several advantages over external references:
     * - It works when injected into another window where a relative link would fail.
     * - It can be restyled directly, unlike with object or embed tags.
     * - It does not need one request per image to load.
     *
     * @author Bo Gotthardt
     * @class SVGContent
     * @constructor
     */
    return AssociatedModel.extend("SVG", {
        defaults: {
            content:   "",
            className: "",
            // SVGs can of course be rescaled freely, but when actually exported as a file they have a particular
            // viewbox size that the element coordinates are relative to. Record this here so that the viewbox can be recreated.
            height:    100,
            width:     100
        },

        /**
         * Create an element for the SVG content.
         *
         * @returns {jQuery} The content as an SVG element wrapped in a div, as a jQuery object.
         */
        createElement() {
            // preserveAspectRatio=none to ensure that the SVG can be rescaled freely, even if the square viewbox ends up in a non-square element.
            // Wrap in div and insert content directly as string since jQuery has problems handling SVG elements.
            const elem = $(`<div><svg xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0 0 ${this.get("width")} ${this.get("height")}' preserveAspectRatio='none'>${this.get("content")}</svg></div>`);
            if (this.get("className")) {
                elem.addClass(this.get("className"));
            }
            return elem;
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/assets/SVGContent.js